export default __webpack_public_path__ + "static/media/manufacturing-experts-icon.de093d40.svg";